import { ContainerType, ShippingLine } from 'types/Shipping';
import { timeList } from './list-of-times';

const DEFAULT_TIME_STRING = '08:00';
export const DEFAULT_TIME = timeList.find((time) => time.key === DEFAULT_TIME_STRING);
const DEFAULT_SHIPPING_LINE_KEY = 'MSC';
const DEFAULT_CONTAINER_TYPE_KEY = "20'";

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const TERMINAL_SCREENSHOTS_TIMERANGE_LIMIT_DAYS = 7;
export const PER_DIEM_RANGE_LIMIT_DAYS = 100;

export function getDefaultSelections(
  shippingLines: ShippingLine[] = [],
  containerTypes: ContainerType[] = []
) {
  const selectedShippingLine = shippingLines.find(
    (shippingLine) => shippingLine.key === DEFAULT_SHIPPING_LINE_KEY
  );
  const shippingLineKey = selectedShippingLine ? selectedShippingLine.key : '';
  const selectedContainerType = containerTypes.find(
    (containerType) => containerType.key === DEFAULT_CONTAINER_TYPE_KEY
  );
  const containerTypeKey = selectedContainerType ? selectedContainerType.key : '';
  return {
    shippingLineKey,
    containerTypeKey,
  };
}
